module.exports = __webpack_public_path__ + "img/preview.3b09ff9f.jpg";